import roverSettings from '@rover/shared/js/utils/rover-settings';
import Route from '@rover/types/src/Route';

import BaseTemplate from '../client/BaseTemplate';

import account from './account';
import backgroundChecks from './backgroundChecks';
import brightHorizons from './brightHorizons';
import careers from './careers';
import checkout from './checkout';
import dev from './dev';
import error from './error';
import facilityBookingSummary from './facilityBookingSummary';
import facilityProfile from './facilityProfile';
import homepage from './homepage';
import landing from './landing';
import lemonadePetInsurance from './lemonadePetInsurance';
import LemonadeTOSPage from './lemonadeTOSPage';
import ownerProfile from './ownerProfile';
import petInsurance from './pet-insurance';
import petProfile from './petProfile';
import petSelector from './petSelector';
import playground from './playground';
import providerProfile from './providerProfile';
import referral from './referral';
import reportAndBlockPage from './reportAndBlock';
import roverProtect from './roverProtect';
import search from './search';
import seo from './seo';
import sitterProfile from './sitterProfile';
import sitterPromotionHub from './sitterPromotionHub';
import sitterPromotionLanding from './sitterPromotionLanding';
import starSitter from './starSitter';
import systems from './systems';
import throw404 from './throw404';
import training from './training';
import welcomeMigratedUser from './welcomeMigratedUser';

export type RouteObject = {
  path?: string;
  component: React.ComponentType<any>;
  routes: Route[];
};

const routes: RouteObject[] = [
  {
    component: BaseTemplate,
    routes: [
      ...account,
      ...brightHorizons,
      ...careers,
      ...homepage,
      ...search,
      ...seo,
      ...petInsurance,
      ...petProfile,
      ...petSelector,
      ...systems,
      ...playground,
      ...landing,
      ...error,
      ...referral,
      ...starSitter,
      ...providerProfile,
      ...reportAndBlockPage,
      ...roverProtect,
      ...sitterProfile,
      ...sitterPromotionHub,
      ...sitterPromotionLanding,
      ...facilityProfile,
      ...training,
      ...facilityBookingSummary,
      ...checkout,
      ...backgroundChecks,
      ...lemonadePetInsurance,
      ...welcomeMigratedUser,
      ...LemonadeTOSPage,
      ...ownerProfile,
      // dev tooling only available in non-production environments
      ...(['development', 'staging'].includes(roverSettings.ROVER_ENVIRONMENT) ? dev : []),
      throw404, // throw404 is a catch all and has to come last
    ],
  },
];

export default routes;
